import React, { useState, useEffect } from "react";
import axios from "axios";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import "bootstrap-icons/font/bootstrap-icons.css";
import Swal from "sweetalert2";

const Withdraw = () => {
    const [loading, setLoading] = useState(false);
    const [withdrawals, setWithdrawals] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showModalCreate, setShowModalcreate] = useState(false);
    const [editTransaction, setEditTransaction] = useState({
        _id: "",
        userName: "",
        password: "",
        link: "",
        min_id: "",
        min_bet: "",
        logo: null,
    });

    useEffect(() => {
        loadWithdrawals();
    }, []);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setEditTransaction({ ...editTransaction, logo: file });
    };

    const loadWithdrawals = async () => {
        setLoading(true);
        try {
            // const response = await axios.get("https://api.Cash365days.in/admin/links");
            const response = await axios.get(`${process.env.REACT_APP_API_URL}admin/links`);
            setWithdrawals(response.data || []);
        } catch (error) {
            console.error("Error fetching withdrawal transactions:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleEditClick = (transaction) => {
        setEditTransaction(transaction);
        setShowModal(true);
    };
    const handleCreateClick = () => {
        setEditTransaction({
            userName: "",
            password: "",
            link: "",
            min_id: "",
            min_bet: "",
            image: null,
        });
        setShowModalcreate(true);
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        setEditTransaction((prev) => ({ ...prev, image: file }));
    };
    // 🔹 Handle Form Submission with FormData
    const handleCreate = async () => {
        setLoading(true);
        try {
            const formData = new FormData();
            formData.append("userName", editTransaction.userName);
            formData.append("password", editTransaction.password);
            formData.append("link", editTransaction.link);
            formData.append("min_id", editTransaction.min_id);
            formData.append("min_bet", editTransaction.min_bet);
            if (editTransaction.image) {
                formData.append("logo", editTransaction.image);
            }

            // const response = await axios.post("https://api.Cash365days.in/admin/links", formData, {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}admin/links`, formData, {

                headers: { "Content-Type": "multipart/form-data" },
            });

            if (response.data.success) {
                Swal.fire("Created!", "New link created successfully.", "success");
                loadWithdrawals(); // Refresh data
                setShowModalcreate(false);
            } else {
                Swal.fire("Error!", response.data.message, "error");
            }
        } catch (error) {
            console.error("Error creating link:", error);
            Swal.fire("Error!", "Failed to create link.", "error");
        } finally {
            setLoading(false);
        }
    };
    const handleUpdate = async () => {
        setLoading(true);

        try {
            const formData = new FormData();
            formData.append("_id", editTransaction._id);
            formData.append("userName", editTransaction.userName);
            formData.append("password", editTransaction.password);
            formData.append("link", editTransaction.link);
            formData.append("min_id", editTransaction.min_id);
            formData.append("min_bet", editTransaction.min_bet);
            if (editTransaction.logo) {
                formData.append("logo", editTransaction.logo);
            }

            const response = await axios.put(
                `${process.env.REACT_APP_API_URL}admin/links/${editTransaction._id}`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            console.log(response.data);

            if (response.data.success) {
                Swal.fire("Updated!", "Transaction updated successfully.", "success");
                loadWithdrawals();
                setShowModal(false);
            } else {
                Swal.fire("Error!", response.data.message, "error");
            }
        } catch (error) {
            console.error("Error updating transaction:", error);
            Swal.fire("Error!", "Failed to update transaction.", "error");
        } finally {
            setLoading(false);
        }
    };


    const handleDelete = async (transactionId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoading(true);
                try {
                    const response = await axios.delete(`${process.env.REACT_APP_API_URL}admin/links/${transactionId}`);

                    if (response.data.success) {
                        Swal.fire("Deleted!", "Transaction has been deleted.", "success");
                        loadWithdrawals();
                    } else {
                        Swal.fire("Error!", response.data.message, "error");
                    }
                } catch (error) {
                    console.error("Error deleting transaction:", error);
                    Swal.fire("Error!", "Failed to delete transaction.", "error");
                } finally {
                    setLoading(false);
                }
            }
        });
    };

    return (
        <div className="profile-container">
            <div className="table-responsive tablemargin">
                <div className="d-flex justify-content-between align-items-center">
                    <h4 className="text-center mt-3 requesthistory">Link List</h4>
                    <Button
                        className="createbutton"
                        onClick={handleCreateClick}
                        title="Add New Transaction"
                    >
                        <i className="bi bi-plus-lg"></i> Add New Link
                    </Button>
                </div>
                {loading ? (
                    <div className="text-center my-3">
                        <Spinner animation="border" role="status" />
                        <p>Loading...</p>
                    </div>
                ) : (
                    <Table striped bordered hover className="tablehistory position-relative">
                        <thead className="text-center">
                            <tr className="tablehead text-center">
                                <th>#</th>
                                <th>UserName</th>
                                <th>Password</th>
                                <th>Link</th>
                                <th>Minimum Id</th>
                                <th>Minimum Amount</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody className="tbodyhistroy">
                            {withdrawals.length > 0 ? (
                                withdrawals.map((transaction, index) => (
                                    <tr className="text-center" key={transaction._id}>
                                        <td>{index + 1}</td>
                                        <td>{transaction.userName}</td>
                                        <td>{transaction.password}</td>
                                        <td>
                                            <a href={transaction.link} target="_blank" rel="noopener noreferrer">
                                                {transaction.link}
                                            </a>
                                        </td>
                                        <td>{transaction.min_id}</td>
                                        <td>{transaction.min_bet}</td>
                                        <td>
                                            <Button
                                                className="buttonAction me-2"
                                                variant="primary"
                                                onClick={() => handleEditClick(transaction)}
                                                title="Edit Transaction"
                                            >
                                                <i className="bi bi-pencil-square"></i>
                                            </Button>
                                            <Button
                                                className="buttonAction"
                                                variant="danger"
                                                onClick={() => handleDelete(transaction._id)}
                                                title="Delete Transaction"
                                            >
                                                <i className="bi bi-trash"></i>
                                            </Button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" className="text-center nodataavl">
                                        No withdrawal transactions available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                )}
            </div>

            {/* Edit Modal */}
            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Transaction</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Logo</Form.Label>
                            <Form.Control
                                type="file"
                                accept="image/*"
                                onChange={handleFileChange}
                            />
                        </Form.Group>

                        {/* Display selected logo */}
                        {editTransaction.logo && (
                            <img
                                src={editTransaction.logo instanceof File
                                    ? URL.createObjectURL(editTransaction.logo)
                                    : `https://api.Cash365days.in/uploads/${editTransaction.logo}`}
                                alt="Logo"
                                width="100"
                                height="80"
                            />
                        )}


                        <Form.Group className="mb-3">
                            <Form.Label>User Name</Form.Label>
                            <Form.Control
                                type="text"
                                value={editTransaction.userName}
                                onChange={(e) => setEditTransaction({ ...editTransaction, userName: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Password</Form.Label>
                            <Form.Control
                                type="text"
                                value={editTransaction.password}
                                onChange={(e) => setEditTransaction({ ...editTransaction, password: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Link</Form.Label>
                            <Form.Control
                                type="text"
                                value={editTransaction.link}
                                onChange={(e) => setEditTransaction({ ...editTransaction, link: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Minimum ID</Form.Label>
                            <Form.Control
                                type="text"
                                value={editTransaction.min_id}
                                onChange={(e) => setEditTransaction({ ...editTransaction, min_id: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Minimum Amount</Form.Label>
                            <Form.Control
                                type="text"
                                value={editTransaction.min_bet}
                                onChange={(e) => setEditTransaction({ ...editTransaction, min_bet: e.target.value })}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" onClick={handleUpdate}>
                        Update
                    </Button>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showModalCreate} onHide={() => setShowModalcreate(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Create Link</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Image</Form.Label>
                            <Form.Control type="file" accept="image/*" onChange={handleImageChange} />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>User Name</Form.Label>
                            <Form.Control
                                type="text"
                                value={editTransaction.userName}
                                onChange={(e) => setEditTransaction({ ...editTransaction, userName: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Password</Form.Label>
                            <Form.Control
                                type="text"
                                value={editTransaction.password}
                                onChange={(e) => setEditTransaction({ ...editTransaction, password: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Link</Form.Label>
                            <Form.Control
                                type="text"
                                value={editTransaction.link}
                                onChange={(e) => setEditTransaction({ ...editTransaction, link: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Minimum ID</Form.Label>
                            <Form.Control
                                type="text"
                                value={editTransaction.min_id}
                                onChange={(e) => setEditTransaction({ ...editTransaction, min_id: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Minimum Amount</Form.Label>
                            <Form.Control
                                type="text"
                                value={editTransaction.min_bet}
                                onChange={(e) => setEditTransaction({ ...editTransaction, min_bet: e.target.value })}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" onClick={handleCreate} disabled={loading}>
                        {loading ? "Creating..." : "Create"}
                    </Button>
                    <Button variant="secondary" onClick={() => setShowModalcreate(false)}>
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default Withdraw;
